import * as React from "react";
import { socialIcons, socialNetworkNames, SocialNetworksId } from "../../interfaces";
import { cn } from "../../lib/utils";
import { Image } from "semantic-ui-react";
interface Props {
  actives?: SocialNetworksId[];
  allSocialNetworks: SocialNetworksId[];
  links?: { [key: string]: string };
  onClick?: (snId: SocialNetworksId) => void;
  size?: "mini" | "big" | "micro";
  showTiktok?: boolean;
  wrap?: boolean;
}

export const SocialNetworksSection: React.FC<Props> = ({
  actives,
  links,
  allSocialNetworks,
  size = "mini",
  wrap = true,
}) => {
  return (
    <div className={cn("w-fit flex flex-row", wrap ? "flex-wrap" : "no-wrap", size === "big" ? "gap-1" : "gap-0")}>
      {allSocialNetworks.map((sn, index) => {
        const link = links ? links[sn] : undefined;
        return (
          <div key={index}>
            <a
              className={cn("p-0", !actives?.includes(sn) || !link ? "cursor-default" : "cursor-pointer")}
              data-elm-id={"socialIcon" + sn}
              target="_blank"
              href={link}
            >
              <Image
                className={cn(
                  "p-1",
                  size === "big"
                    ? "min-w-10 max-w-10 min-h-10 max-h-10"
                    : size === "mini"
                    ? "min-w-7 max-w-7 min-h-7 max-h-7"
                    : "min-w-6 max-w-6 min-h-6 max-h-6",
                  actives?.includes(sn) ? "opacity-100" : "opacity-40 grayscale-100"
                )}
                title={socialNetworkNames[sn]}
                src={socialIcons[sn]}
                size="small"
                circular
              />
            </a>
          </div>
        );
      })}
    </div>
  );
};
